import { v4 as uuidv4 } from 'uuid';
import { AvailabilityEnum } from '../../../products/ProductTypes';
import { toOfflineAvailability } from '../../../products/utils/availability.utils';
import { offlineProductColorsRepository } from '../../repositories/offlineProductColors.repository';
import { offlineSkusRepository } from '../../repositories/offlineSkus.repository';
import { CreateGridParams } from '../../stores/offlineOrders/types/offlineOrders.actions.types';

export default class ShopProductUtils {
  static async getGridItemToAddProduct(productColorId: string): Promise<CreateGridParams> {
    const productColor = await offlineProductColorsRepository.getByIdOrFail(productColorId);
    const skus = await offlineSkusRepository.findByProductColorId(productColorId);

    if (!skus.length) {
      throw new Error(`no skus found for product color [${productColorId}]`);
    }

    const availability =
      productColor.availabilities.length > 1
        ? AvailabilityEnum.EMPTY
        : productColor.availabilities[0];

    const commonParams: Pick<CreateGridParams, 'quantity' | 'id' | 'productColorId' | 'skuId'> = {
      quantity: 0,
      id: uuidv4(),
      productColorId,
      skuId: skus[0].id,
    };

    switch (availability) {
      case AvailabilityEnum.INFINITE_PRE_ORDER:
      case AvailabilityEnum.FUTURE_STOCK: {
        const deliveryWindows =
          availability === AvailabilityEnum.FUTURE_STOCK
            ? productColor.deliveryWindowIds.futureStock
            : productColor.deliveryWindowIds.preOrder;

        if (deliveryWindows.length === 1) {
          return {
            ...commonParams,
            availability: toOfflineAvailability(availability),
            deliveryWindowId: deliveryWindows[0],
          };
        }
        return {
          ...commonParams,
          availability: AvailabilityEnum.EMPTY,
          deliveryWindowId: undefined,
        };
      }

      case AvailabilityEnum.READY_FOR_DELIVERY:
        return {
          ...commonParams,
          availability,
          deliveryWindowId: undefined,
        };

      case AvailabilityEnum.EMPTY:
        return {
          ...commonParams,
          availability,
          deliveryWindowId: undefined,
        };

      default:
        throw new Error(
          `invalid availability [${availability}] for product color [${productColorId}]`,
        );
    }
  }
}
